export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_OWN_PRODUCTS = 'GET_OWN_PRODUCTS';
export const GET_OWN_PRODUCTS_SUCCESS = 'GET_OWN_PRODUCTS_SUCCESS';
export const GET_BRANDS = 'GET_BRANDS';
export const GET_BRANDS_SUCCESS = 'GET_BRANDS_SUCCESS';
export const GET_HOME = 'GET_HOME';
export const GET_HOME_SUCCESS = 'GET_HOME_SUCCESS';
export const GET_PLANS = 'GET_PLANS';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const SEARCH_PRODUCT = 'SEARCH_PRODUCT';
export const SEARCH_PRODUCT_SUCCESS = 'SEARCH_PRODUCT_SUCCESS';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const REMOVE_PRODUCT_SUCCESS = 'REMOVE_PRODUCT_SUCCESS';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const EDIT_PRODUCT_SUCCESS = 'EDIT_PRODUCT_SUCCESS';
export const CANCEL_GET_PRODUCTS = 'CANCEL_GET_PRODUCTS';
export const CLEAR_SEARCH_STATE = 'CLEAR_SEARCH_STATE';
export const SET_LAST_REF_KEY = 'SET_LAST_REF_KEY';
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS';
export const CLEAR_OWN_PRODUCTS = 'CLEAR_OWN_PRODUCTS';

export const SIGNIN = 'SIGNIN';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNOUT = 'SIGNOUT';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SIGNIN_WITH_GOOGLE = 'SIGNIN_WITH_GOOGLE';
export const SIGNIN_WITH_FACEBOOK = 'SIGNIN_WITH_FACEBOOK';
export const ON_AUTHSTATE_CHANGED = 'ON_AUTHSTATE_CHANGED';
export const SET_AUTH_PERSISTENCE = 'SET_AUTH_PERSISTENCE';
export const ON_AUTHSTATE_SUCCESS = 'ON_AUTHSTATE_SUCCESS';
export const ON_AUTHSTATE_FAIL = 'ON_AUTHSTATE_FAIL';
export const RESET_PASSWORD = 'RESET_PASSWORD';

export const UPDATE_EMAIL = 'UPDATE_EMAIL';
export const SET_PROFILE = 'SET_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';

export const SET_TEXT_FILTER = 'SET_TEXT_FILTER';
export const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
export const SET_SUB1_FILTER = 'SET_SUB1_FILTER';
export const SET_SIZE_FILTER = 'SET_SIZE_FILTER';
export const SET_YEAR_FILTER = 'SET_YEAR_FILTER';
export const SET_BRAND_FILTER = 'SET_BRAND_FILTER';
export const SET_WEIGHT_FILTER = 'SET_WEIGHT_FILTER';
export const SET_ASSISTED_FILTER = 'SET_ASSISTED_FILTER';
export const SET_WHEELS_FILTER = 'SET_WHEELS_FILTER';
export const SET_REGION_FILTER = 'SET_REGION_FILTER';
export const SET_PROVINCE_FILTER = 'SET_PROVINCE_FILTER';
export const SET_NPA_FILTER = 'SET_NPA_FILTER';
export const SET_MIN_PRICE_FILTER = 'SET_MIN_PRICE_FILTER';
export const SET_MAX_PRICE_FILTER = 'SET_MAX_PRICE_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const APPLY_FILTER = 'APPLY_FILTER';
export const CLEAR_RECENT_SEARCH = 'CLEAR_RECENT_SEARCH';
export const REMOVE_SELECTED_RECENT = 'REMOVE_SELECTED_RECENT';

export const REGISTER_USER = 'REGISTER_USER';
export const GET_USER = 'GET_USER';
export const DELETE_USER = 'DELETE_USER';
export const EDIT_USER = 'EDIT_USER';
export const ADD_USER = 'ADD_USER';

export const LOADING = 'LOADING';
export const IS_AUTHENTICATING = 'IS_AUTHENTICATING';
export const SET_REQUEST_STATUS = 'SET_REQUEST_STATUS';

export const CREATE_CHAT = 'CREATE_CHAT';
